"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _appConfigContext = require("./appConfigContext");
Object.keys(_appConfigContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _appConfigContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _appConfigContext[key];
    }
  });
});
var _footerContext = require("./footerContext");
Object.keys(_footerContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _footerContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _footerContext[key];
    }
  });
});
